import { Component, OnInit } from "@angular/core";
import { ViewCell } from "ng2-smart-table";

@Component({
  template: `
  <div *ngIf="visible" class="element-list-container overflow-auto">
    <nb-list nbInfiniteList>
        <nb-list-item *ngFor="let element of value;let i = index">
         {{ element }}
        </nb-list-item>
      </nb-list>
      </div>
  `,
  styles: [`

    .element-list-container{
    max-height: 100px;
    margin:-0.875rem -1.25rem;
  }

   ::ng-deep  .element-list-container nb-list-item{
    padding:0.45rem;
  }


  `
  ]


})
export class ElementsPropertyRenderComponent implements ViewCell, OnInit {
  value: string | number | any;

  rowData: any;
  visible: boolean;
  ngOnInit(): void {
    this.visible = this.value.length > 0 && this.value[0] != '';

  }

}
